import React from 'react';
import './PanelDetails.css';

function PanelDetails() {
  return React.createElement(
    'div',
    { className: 'panel-details-page' },
    React.createElement(
      'main',
      { className: 'panel-container' },
      
      React.createElement('h1', { className: 'panel-title' }, 'Join our research panel'),
      
      React.createElement(
        'p',
        { className: 'panel-lead' },
        'We run focus groups, surveys and interviews with people from all cultural backgrounds across South Australia. What we learn helps businesses, government and community organisations understand what multicultural communities actually need.'
      ),

      React.createElement(
        'section',
        { className: 'panel-section' },
        React.createElement('h2', { className: 'panel-heading' }, "Who we're looking for"),
        React.createElement(
          'p',
          { className: 'panel-text' },
          "Anyone aged 18 or over from a culturally or linguistically diverse background. You don't need research experience, and you don't need strong English — we work in over 20 languages."
        )
      ),

      React.createElement(
        'section',
        { className: 'panel-section' },
        React.createElement('h2', { className: 'panel-heading' }, "What's involved"),
        React.createElement(
          'p',
          { className: 'panel-text' },
          "Registering doesn't commit you to anything. We'll get in touch when a study matches your background or interests, and you decide each time whether to take part. Most sessions run for an hour or two, online or in person."
        )
      ),

      React.createElement(
        'section',
        { className: 'panel-section' },
        React.createElement('h2', { className: 'panel-heading' }, 'Your information'),
        React.createElement(
          'p',
          { className: 'panel-text' },
          'The registration form asks about your background, languages and interests so we can match you to the right studies. We only use it for that. You can ask us to take you off the list at any time.'
        )
      ),

      React.createElement(
        'div',
        { className: 'panel-actions' },
        React.createElement(
          'a',
          {
            href: 'https://mccsa.org.au/tnm-focus-group-participant-form/',
            target: '_blank',
            rel: 'noopener noreferrer',
            className: 'primary-btn'
          },
          'Register your interest'
        ),
        React.createElement(
          'p',
          { className: 'panel-subtext' },
          "The form is hosted on our parent organisation's website, MCCSA."
        )
      )
    )
  );
}

export default PanelDetails;